/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeetingNoteResponse
 */
export interface MeetingNoteResponse {
    /**
     * Full text of the meeting note
     * @type {string}
     * @memberof MeetingNoteResponse
     */
    note?: string;
}

/**
 * Check if a given object implements the MeetingNoteResponse interface.
 */
export function instanceOfMeetingNoteResponse(value: object): boolean {
    return true;
}

export function MeetingNoteResponseFromJSON(json: any): MeetingNoteResponse {
    return MeetingNoteResponseFromJSONTyped(json, false);
}

export function MeetingNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeetingNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function MeetingNoteResponseToJSON(value?: MeetingNoteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'note': value['note'],
    };
}

